import styled from 'styled-components';

const HEADER_TEXT_MAXSIZE = 12;

//----------------------------------------------------------------------
export const StyledStatsPadStyle = styled.div({
  border: '0px solid #CCCCCC44',
  color: '#1C7ED6',
  display: 'inline-block',
  fontSize: '12px',
  marginRight: 10,
  marginTop: 1,
  opacity: 1,
  padding: 2,
});

//----------------------------------------------------------------------
const getBackgroundColorHeaderSmallImg = (props) => {
  if (props.$active) return '#E7F5FF';
  return props?.$backgroundColor || '#FFFFFF';
};
export const StyledNavigHeaderSmallImg = styled.img({
  alignSelf: 'center',
  backgroundColor: (props) => getBackgroundColorHeaderSmallImg(props),
  borderLeft: (props) =>
    props.$active ? '1px solid #6560A8' : '1px solid var(--ds-border-intense)',

  color: (props) => (props.$active ? 'black' : 'white'),
  cursor: 'pointer',
  float: 'right',
  fontSize: '11px',
  height: '100%',
  padding: '3px',
  width: '30px',
  opacity: 0.8,
  ':hover': {
    opacity: '1',
  },
});

//----------------------------------------------------------------------
export const StyledHeaderStatDiv = styled.div({
  backgroundColor: 'var(--ds-bg-base)',
  borderBottom: `1px solid var(--ds-border-base)`,
  fontFamily: 'proxima-nova',
  fontSize: '16',
  height: '55px',
  marginLeft: '15px',
  paddingBottom: '10px',
  paddingLeft: '5px',
  paddingTop: '8px',
  width: 'calc(100% - 45px)',
});
//------------------------------------------------------------------------------------------------
export const StyledDivHeader = styled.div({
  backgroundColor: 'var(--ds-bg-base)',
  borderRight: '1px dashed var(--ds-border-base)',
  height: '100%',
  left: (props) => `${props.$x}px`,
  overflow: 'hidden',
  position: 'absolute',
  width: '100%',
  opacity: '1',
  ':hover': {
    opacity: '1',
    overflow: 'visible',
  },

  '&:hover .iconImgHeader': {
    backgroundColor: 'var(--ds-bg-base) !important', // color of the mask
    border: '0px solid var(--ds-base)',
  },

  '&:hover .IconImgHeaderContainer': {
    backgroundColor: 'var(--ds-base) !important',
    border: '0px solid var(--ds-base)',
    borderTopLeftRadius: '5px',
    borderBottomLeftRadius: '5px',
  },

  '&:hover .objFilterItemContainer': {
    // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  },

  '&:hover': {
    '& .blocIcons': {
      display: 'inline-flex',
      border: '0px solid var(--ds-base)',
      borderRight: '8px solid var(--ds-base) ',
      borderLeft: '0px solid var(--ds-border-base) ',
      backgroundColor: 'var(--ds-bg-base)',
      zIndex: 99999999,
      // boxShadow: '0 3px 4px rgba(0, 0, 0, 0.2)',
      opacity: 1,
    },
    '& .blocIcons img': {
      display: 'inline',
      opacity: '0.5',
    },

    '& .mantine-Select-input': {
      border: ' 1px solid var(--ds-base)',
      borderRadius: '0px',
      border: '0px',
    },

    '& .styledDivHeaderContent': {
      boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
      border: '1px solid var(--ds-base)',
      zIndex: 100000000,
      display: 'inline-flex',
      width: 'max-content',
      backgroundColor: 'var(--ds-bg-base)',
      position: 'relative',
      transition: 'all 0.2s ease-in-out',
    },
  },
  '& .blocIcons img': {
    display: 'none',
  },

  '.blocIcons ': {
    opacity: 0,
    transition: 'opacity 0.6s',
    borderRadius: '0px 3px 3px 0px',
  },
  '.btnMoreAction': {
    marginTop: '5px',
    display: 'none',
  },
});

export const StyledDivHeaderContent = styled.div({
  display: 'flex',
  flexDirection: 'row',
  borderRadius: '7px',
  marginTop: '0px',
  marginBottom: '10px',
  overflow: 'visible',
  // paddingTop: '4px',
  width: 'fit-content',
  height: 'fit-content',
  position: 'relative',
  ':hover': {
    zIndex: 99999999,
    position: 'relative',
  },
  '.arrange-icon': {
    marginRight: '2px',
    marginTop: '0px',
  },
});

export const IconMask = styled.div((props) => ({
  width: '16px',
  height: '16px',
  flexShrink: 0,
  backgroundColor: props.$color,
  mask: `url('${encodeURI(props.$icon ?? '/img/alert.svg')}') no-repeat center`,
  maskRepeat: 'no-repeat',
  maskSize: '16px 16px',
}));
//------------------------------------------------------------------------------------------------
export const BlocIcons = styled.div({
  height: '36px',
  width: 'auto',
  whiteSpace: 'nowrap',
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  paddingLeft: '3px',
  paddingRight: '3px',
  opacity: 0,
  top: '0px',
  '& img': {},

  ':hover img': {
    display: 'inline',
    backgroundColor: 'var(--ds-bg-secondary)',
  },
  ':hover .btnMoreAction': {
    display: 'none',
  },
});

export const StyleHeaderTopContainer = styled.div({});
//------------------------------------------------------------------------------------------------
export const StyledHeaderTop = styled.div({
  ':first-child': {},
  ':last-child': {
    borderTopRightRadius: '7px',
    borderBottomRightRadius: '7px',
  },

  '&:hover': {
    borderBottomRightRadius: '7px',
    borderTopRightRadius: '7px',
    opacity: '1',
    fontWeight: '600',
  },

  backgroundColor: (props) =>
    props.$hover ? 'var(--ds-bg-secondary)' : 'var(--ds-bg-base)',
  borderLeft: (props) => `3px solid ${props.$color}`,
  borderRadius: '0px',
  borderTopLeftRadius: '7px',
  bottom: 0,
  boxShadow: '-1px 1px 1px 0px #cccccc88',
  color: 'white',
  fontSize: '12px',
  fontWeight: (props) => (props.$hover ? '550' : '450'),
  height: '26px',
  left: (props) => `${10 + props.$posX}px`, // +props.width,
  minWidth: (props) => (props.$hover ? props.$width : ''),
  opacity: '1',
  overflow: (props) => (props.$hover ? 'visible' : 'hidden'),
  paddingLeft: 6,
  paddingRight: (props) => (props.$hover ? '30' : ''),
  paddingTop: 0,
  position: 'absolute',
  textTransform: 'capitalize',
  transformOrigin: '0% 0%',
  transition: 'width 0.3s, left 0.3s, height 0.3s',
  width: '100%',
  zIndex: (props) => 60000 + props.$posX + 1000 * props.$level,
});
export const StatsPadContent = styled.div({
  backgroundColor: 'red',
  borderRadius: '5px',
  boxShadow: '1px 1px 2px #CCC',
  height: '50px',
  padding: '5px',
  width: '50px',
});

export const StyledDivHeaderContentTooltip = styled.div({
  // borderRadius: '3px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  color: '#AAA',
  cursor: 'pointer',
  float: 'right',
  fontSize: '15px',
  fontWeight: '550',
  height: 'auto',
  marginLeft: 10,
  marginRight: 10,
  paddingLeft: '5px',
  paddingRight: '5px',
  paddingTop: '0px',
});

export const ArrowSortSpan = styled.span({
  fontSize: '11px',
  marginLeft: '5px',
  marginTop: '4px',
  ':hover': {
    color: 'var(--ds-base)',
  },
});

export const StyledHeaderTopContent = styled.div({
  display: 'inline-flex', // ⬅️ permet d'avoir icône + texte sur la même ligne
  alignItems: 'center', // ⬅️ alignement vertical
  gap: '4px', // ⬅️ espace entre icône et texte
  color: (props) => props.$color,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
  fontFamily: 'proxima-nova',
  fontSize: HEADER_TEXT_MAXSIZE,
});
